import axiosClient from "./axiosClient";

export const obtenerMiEstado = () => axiosClient.get("/familia/mi-estado").then((r) => r.data);
export const listarSugerencias = (prefijo) => axiosClient.get("/familia/sugerencias", { params: { prefijo } }).then((r) => r.data);
export const buscarPorNombre = (nombre) => axiosClient.post("/familia/buscar", { nombre }).then((r) => r.data);
export const crearFamilia = (nombre, monedaId) => axiosClient.post("/familia/crear", { nombre, monedaId }).then((r) => r.data);
export const solicitarUnirse = (nombre) => axiosClient.post("/familia/solicitar", { nombre }).then((r) => r.data);
export const cancelarSolicitud = () => axiosClient.post("/familia/cancelar-solicitud").then((r) => r.data);
export const invitarMiembro = (email) => axiosClient.post("/familia/invitar", { email }).then((r) => r.data);
export const salirDeFamilia = () => axiosClient.post("/familia/salir").then((r) => r.data);
export const noParticipar = () => axiosClient.post("/familia/no-participar").then((r) => r.data);

export const obtenerSolicitud = (token) => axiosClient.get(`/familia/solicitudes/${token}`).then((r) => r.data);
export const resolverSolicitud = (token, aprobar) =>
  axiosClient.post(`/familia/solicitudes/${token}/resolver`, { aprobar }).then((r) => r.data);

export const obtenerInvitacion = (token) => axiosClient.get(`/familia/invitaciones/${token}`).then((r) => r.data);
export const resolverInvitacion = (token, aceptar) =>
  axiosClient.post(`/familia/invitaciones/${token}/resolver`, { aceptar }).then((r) => r.data);
